import { commandType } from "./Attributes";

export const Skeleton = {
    type: commandType,
    settings: {
        picture_distance: "",
    },
};
